import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../core/base.service';
import { 
  CupomResponse, 
  CupomListResponse, 
  ParceiroParaCupomResponse, 
  CupomCadastroRequest, 
  CupomAtualizarRequest, 
  CupomFiltroRequest 
} from 'app/shared/models/ei-models';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CupomService extends BaseService {
  private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Cupom/');

  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  verificarCupom(cupom: string): Observable<CupomResponse> {
    return this.httpClient.get<CupomResponse>(
      this.controllerEndpoint.concat(`VerificarCupom/${cupom}`),
      { headers: this.getHeader(true) }
    );
  }

  // Listar cupons com filtros
  listar(filtro?: CupomFiltroRequest): Observable<CupomListResponse[]> {
    let params = new HttpParams();
    if (filtro?.codigo) params = params.set('codigo', filtro.codigo);
    if (filtro?.parceiroId) params = params.set('parceiroId', filtro.parceiroId.toString());
    if (filtro?.ativo !== undefined && filtro?.ativo !== null) {
      params = params.set('ativo', filtro.ativo.toString());
    }

    return this.httpClient.get<CupomListResponse[]>(
      this.controllerEndpoint,
      { headers: this.getHeader(true), params }
    );
  }

  // Obter por ID
  obterPorId(id: number): Observable<CupomResponse> {
    return this.httpClient.get<CupomResponse>(
      this.controllerEndpoint.concat(`${id}`),
      { headers: this.getHeader(true) }
    );
  }

  // Listar cupons de um parceiro
  listarPorParceiro(parceiroId: number): Observable<CupomResponse[]> {
    return this.httpClient.get<CupomResponse[]>(
      this.controllerEndpoint.concat(`parceiro/${parceiroId}`),
      { headers: this.getHeader(true) }
    );
  }

  // Cadastrar
  cadastrar(request: CupomCadastroRequest): Observable<CupomResponse> {
    return this.httpClient.post<CupomResponse>(
      this.controllerEndpoint,
      request,
      { headers: this.getHeader(true) }
    );
  }

  // Atualizar
  atualizar(request: CupomAtualizarRequest): Observable<CupomResponse> {
    return this.httpClient.put<CupomResponse>(
      this.controllerEndpoint,
      request,
      { headers: this.getHeader(true) }
    );
  }

  // Ativar
  ativar(id: number): Observable<any> {
    return this.httpClient.patch(
      this.controllerEndpoint.concat(`${id}/ativar`),
      {},
      { headers: this.getHeader(true) }
    );
  }

  // Desativar
  desativar(id: number): Observable<any> {
    return this.httpClient.patch(
      this.controllerEndpoint.concat(`${id}/desativar`),
      {},
      { headers: this.getHeader(true) }
    );
  }

  // Listar parceiros para dropdown
  listarParceiros(): Observable<ParceiroParaCupomResponse[]> {
    return this.httpClient.get<ParceiroParaCupomResponse[]>(
      this.controllerEndpoint.concat('parceiros'),
      { headers: this.getHeader(true) }
    );
  }
}
